// Generated by LiveScript 1.6.0
var ref$, id, log, wrap, delay, Slideshow;
ref$ = require('utils'), id = ref$.id, log = ref$.log, wrap = ref$.wrap, delay = ref$.delay;
module.exports = Slideshow = function($host, config, $$){
  var activeClass, $slides, state, limit, selectVideo, playVideo, stopVideo, next;
  activeClass = 'is-active';
  $slides = $$('[data-slide]');
  state = {
    interval: config.interval * 1000,
    current: -1,
    playing: $slides.length > 1
  };
  limit = wrap(0, $slides.length - 1);
  selectVideo = function($selection){
    return $selection.find('video').get(0);
  };
  playVideo = function($slide){
    var video;
    video = selectVideo($slide);
    video.currentTime = 0;
    return video.play();
  };
  stopVideo = function($slide){
    var video;
    video = selectVideo($slide);
    return video.pause();
  };
  next = function(){
    var $prev, $next;
    $prev = $slides.eq(state.current);
    state.current = limit(state.current + 1);
    $next = $slides.eq(state.current);
    $slides.removeClass(activeClass);
    if ($prev.hasClass('video')) {
      stopVideo($prev);
    }
    $next.addClass(activeClass);
    if ($next.hasClass('video')) {
      playVideo($next);
    }
    if (state.playing) {
      if ($next.hasClass('image')) {
        return delay(state.interval, next);
      } else {
        return delay(selectVideo($next).duration * 1000, next);
      }
    }
  };
  if ($slides.length > 1) {
    auto();
  } else {
    $slides.addClass(activeClass);
    playVideo($slides);
  }
  return {
    next: next,
    stop: function(){
      return state.playing = false;
    }
  };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNsaWRlc2hvdy5scyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLElBQUEsR0FBMkIsT0FBM0IsQ0FBbUMsT0FBQSxDQUFuQyxFQUFFLEVBQXVCLENBQUEsQ0FBQSxDQUF6QixJQUFBLENBQUEsRUFBQSxFQUFNLEdBQW1CLENBQUEsQ0FBQSxDQUF6QixJQUFBLENBQUEsR0FBQSxFQUFXLElBQWMsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQSxJQUFBLEVBQWlCLEtBQVEsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQTtBQU9BLE1BQU0sQ0FBQyxPQUFRLENBQUEsQ0FBQSxDQUFFLFNBQVUsQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEtBQUEsRUFBQSxNQUFBLEVBQUEsRUFBQTs7RUFFM0IsV0FBYSxDQUFBLENBQUEsQ0FBRTtFQUdmLE9BQVEsQ0FBQSxDQUFBLENBQUUsR0FBRyxjQUFEO0VBR1osS0FBTSxDQUFBLENBQUEsQ0FDSjtJQUFBLFVBQVUsTUFBTSxDQUFDLFFBQVMsQ0FBQSxDQUFBLENBQUU7SUFDNUIsU0FBUyxDQUFBO0lBQ1QsU0FBUyxPQUFPLENBQUMsTUFBTyxDQUFBLENBQUEsQ0FBRTtFQUYxQjtFQUtGLEtBQU0sQ0FBQSxDQUFBLENBQUUsS0FBSyxHQUFHLE9BQU8sQ0FBQyxNQUFPLENBQUEsQ0FBQSxDQUFFLENBQXBCO0VBRWIsV0FBYSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsVUFBQTtXQUNiLFVBQVUsQ0FBQyxLQUFLLE9BQUEsQ0FBTyxDQUFDLElBQUksQ0FBQTs7RUFFOUIsU0FBVyxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsTUFBQTs7SUFDWCxLQUFNLENBQUEsQ0FBQSxDQUFFLFlBQWEsTUFBQTtJQUNyQixLQUFLLENBQUMsV0FBYSxDQUFBLENBQUEsQ0FBRTtXQUNyQixLQUFLLENBQUMsS0FBSTs7RUFFWixTQUFXLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxNQUFBOztJQUNYLEtBQU0sQ0FBQSxDQUFBLENBQUUsWUFBYSxNQUFBO1dBQ3JCLEtBQUssQ0FBQyxNQUFLOztFQUViLElBQUssQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBOztJQUNMLEtBQU0sQ0FBQSxDQUFBLENBQUUsT0FBTyxDQUFDLEdBQUcsS0FBSyxDQUFDLE9BQU47SUFDbkIsS0FBSyxDQUFDLE9BQVEsQ0FBQSxDQUFBLENBQUUsTUFBTSxLQUFLLENBQUMsT0FBUSxDQUFBLENBQUEsQ0FBRSxDQUFoQjtJQUN0QixLQUFNLENBQUEsQ0FBQSxDQUFFLE9BQU8sQ0FBQyxHQUFHLEtBQUssQ0FBQyxPQUFOO0lBR25CLE9BQU8sQ0FBQyxZQUFhLFdBQUE7SUFDckIsSUFBRyxLQUFLLENBQUMsUUFBVCxDQUFtQixPQUFBLENBQW5CO01BQStCLFVBQVcsS0FBQTs7SUFHMUMsS0FBSyxDQUFDLFNBQVUsV0FBQTtJQUNoQixJQUFHLEtBQUssQ0FBQyxRQUFULENBQW1CLE9BQUEsQ0FBbkI7TUFBK0IsVUFBVyxLQUFBOztJQUcxQyxJQUFHLEtBQUssQ0FBQyxPQUFUO01BQ0UsSUFBRyxLQUFLLENBQUMsUUFBVCxDQUFtQixPQUFBLENBQW5CO2VBQ0UsTUFBTSxLQUFLLENBQUMsVUFBVSxJQUFoQjtPQUNSO2VBQ0UsTUFBTyxXQUE2QixDQUFoQixLQUFBLENBQU0sQ0FBQyxRQUFTLENBQUEsQ0FBQSxDQUFFLE1BQU0sSUFBdEM7Ozs7RUFHWixJQUFHLE9BQU8sQ0FBQyxNQUFPLENBQUEsQ0FBQSxDQUFFLENBQXBCO0lBQ0UsS0FBSTtHQUNOO0lBQ0UsT0FBTyxDQUFDLFNBQVUsV0FBQTtJQUNsQixVQUFXLE9BQUE7O1NBSWI7SUFBQSxNQUFNO0lBQ04sTUFBTSxRQUFBLENBQUE7YUFBRyxLQUFLLENBQUMsT0FBUSxDQUFBLENBQUEsQ0FBRTs7RUFEekIiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

